import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityRolesActividadAdapter, EntityRolesActividadState } from './entity-roles-actividad.state';

const { selectEntities, selectAll } =
  entityRolesActividadAdapter.getSelectors();

export const getError = (state: EntityRolesActividadState): any => state.error;

export const getIsLoading = (state: EntityRolesActividadState): boolean =>
  state.isLoading;

export const selectRolesActividadState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.rolesActividad
);

export const selectAllRolesActividad = createSelector(
  selectRolesActividadState,
  selectAll
);
export const selectEntitiesRolesActividad = createSelector(
  selectRolesActividadState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectRolesActividadError = createSelector(
  selectRolesActividadState,
  getError
);

// MemoizedSelector<object,any>
export const selectRolesActividadIsLoading = createSelector(
  selectRolesActividadState,
  getIsLoading
);
